export default __webpack_public_path__ + "static/media/orangeRoot.a9dd94d6.png";